<template>
  <div class="app">
    <pre-loader v-if="loading"/>
    <router-view v-else/>
    <cookie-banner/>
  </div>
</template>

<script>
import PreLoader from "./components/UI/PreLoader";
import CookieBanner from "./components/UI/CookieBanner";
import update from "./mixins/update";
import { getSubdomain } from "@/utils/domain";
import { initRuntimeAnalytics } from "@/services/runtimeAnalytics";
import { analyticsConsent } from "@/services/analyticsConsent";

export default {
  components: {PreLoader, CookieBanner},
  mixins: [update],
  data: ()=>{
  return{
    loading: true,
    pendingAnalytics: null,
  }
},
mounted() {
  if (this.$store.state.user.authToken){
      this.$store.dispatch('GET_USER_DETAILS')
        .finally(()=>this.loading = false)
  } else {
    this.loading = false
  }

  this.initMetrika()
  this.fetchRuntimeAnalyticsConfig()

  // Подписываемся на событие согласия из CookieBanner
  this.emitter.on('analytics-accepted', () => {
    this.startRuntimeAnalytics()
  })
},
beforeUnmount() {
  this.emitter.off('analytics-accepted')
},
methods: {
  initMetrika() {
    if (analyticsConsent.isAccepted()) {
      this.loadYandexMetrika()
    }
  },
  loadYandexMetrika() {
    if (window.ym) return

    window.ym = function() {
      window.ym.a = window.ym.a || []
      window.ym.a.push(arguments)
    }
    window.ym.l = 1 * new Date()

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://mc.yandex.ru/metrika/tag.js'

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)

    window.ym(91077058, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    })
  },
  fetchRuntimeAnalyticsConfig() {
    const slug = getSubdomain()
    if (!slug) {
      return
    }

    this.$api.getCityAnalytics(slug)
      .then((response) => {
        this.pendingAnalytics = response.analytics

        // Если пользователь уже дал согласие — запускаем аналитику сразу
        if (analyticsConsent.isAccepted()) {
          this.startRuntimeAnalytics()
        }
      })
      .catch(() => {
        // Не ломаем приложение при ошибке загрузки аналитики
      })
  },
  startRuntimeAnalytics() {
    if (this.pendingAnalytics) {
      initRuntimeAnalytics(this.pendingAnalytics)
      this.pendingAnalytics = null
    }
  },
}
}
</script>

<style scoped>
.app{
  min-height: 100vh;
}
/*.collapse-enter-active,*/
/*.collapse-leave-active {*/
/*  transition: max-height .9s;*/
/*}*/
/*.collapse-enter-from,*/
/*.collapse-leave-to {*/
/*  max-height: 0;*/
/*  opacity: 0;*/
/*}*/
</style>
